import { ThunderboltFilled } from "@ant-design/icons";
import { Button, Input, message, Select, Steps } from "antd";
import { useFormik } from "formik";
import moment from "moment";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import * as yup from "yup";
import {
  AddUserTrip,
  addUserTrip,
  addUserTripReset,
  userTripFields,
} from "../../actions/trips";
import CarRentals from "./CarRentals";
import FlightData from "./FlightData";
import HotelForm from "./HotelForm";
import OtherBooking from "./OtherBookings";
import { countries } from "../Settings/Organisation/country";

const AddTripComponent = () => {
  const [isFlightModalVisible, setIsFlightModalVisible] = React.useState(false);
  const [isHotelsModalVisible, setIsHotelsModalVisible] = React.useState(false);
  const [isCarModalVisible, setIsCarModalVisible] = React.useState(false);
  const [isOtherModalVisible, setIsOtherModalVisible] = React.useState(false);
  const [validationSchema, setValidationSchema] = React.useState(null);

  const tripForm = useFormik({
    initialValues: {
      field_values: {},
      hotel_reservations: [],
      car_rentals: [],
      other_bookings: [],
      flight_reservations: {},
    },
    enableReinitialize: true,
    validateOnBlur: false,
    validateOnChange: false,
    validateOnMount: false,
    validationSchema,
    onSubmit: (values) => {
      let vals = { ...values };
      vals.field_values = Object.keys(vals.field_values).map((ele) => ({
        id: ele,
        value: vals.field_values[ele],
      }));
      if (isFlightModalVisible) {
        setIsFlightModalVisible(false);
        return;
      }
      if (isCarModalVisible) {
        setIsCarModalVisible(false);
        return;
      }
      if (isHotelsModalVisible) {
        setIsHotelsModalVisible(false);
        return;
      }

      if (isOtherModalVisible) {
        setIsOtherModalVisible(false);
        return;
      }

      if (tripData?.id) {
        vals.id = tripData?.id;
        dispatch(addUserTrip(vals));
      } else {
        dispatch(addUserTrip(vals));
      }
    },
  });

  const history = useHistory();
  const dispatch = useDispatch();
  const {
    location: { state: { tripData = {} } = {} },
  } = history;

  const userTripsAddResponse = useSelector(
    (state) => state.trips.addUserTrip || {},
  );
  const userTripFieldsResponse = useSelector(
    (state) => state.trips.userTripFields || {},
  );

  const { data: { response: { fields = [] } = {} } = {} } =
    userTripFieldsResponse;

  React.useEffect(() => {
    if (tripData?.id)
      dispatch(
        userTripFields({
          id: tripData?.id,
        }),
      );
    else dispatch(userTripFields());

    return () => {
      dispatch(addUserTripReset());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React.useEffect(() => {
    const { data: { message: res_message = "", status = "" } = {} } =
      userTripsAddResponse;
    if (status) {
      history.push("/trips/");
      dispatch({
        type: AddUserTrip.RESET,
      });
      // dispatch(trips({ trip_id: tripsData.id }));
    } else if (status === false) {
      dispatch({
        type: AddUserTrip.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userTripsAddResponse]);

  React.useEffect(() => {
    if (fields?.length > 0 && tripData?.id) {
      let flight_reservations = { ...tripData?.flight_reservations };
      let trips = tripData?.flight_reservations.trips?.map((ele) => {
        return {
          ...ele,
          departure_date: moment(
            ele.departure_date,
            "DD-MM-YYYY, HH:mm:ss a",
          ).format("DD/MM/YYYY HH:mm:ss a"),
          return_date: ele.return_date
            ? moment(ele.return_date, "DD-MM-YYYY, HH:mm:ss a").format(
              "DD/MM/YYYY HH:mm:ss a",
            )
            : "",
        };
      });
      let hotels = tripData?.hotel_reservations?.map((ele) => {
        return {
          ...ele,
          duration_from: moment(
            ele.duration_from,
            "DD-MM-YYYY, HH:mm:ss a",
          ).format("DD/MM/YYYY HH:mm:ss a"),
          duration_to: ele.duration_to
            ? moment(ele.duration_to, "DD-MM-YYYY, HH:mm:ss a").format(
              "DD/MM/YYYY HH:mm:ss a",
            )
            : "",
        };
      });
      let car_rentals = tripData?.car_rentals?.map((ele) => {
        return {
          ...ele,
          duration_from: moment(
            ele.duration_from,
            "DD-MM-YYYY, HH:mm:ss a",
          ).format("DD/MM/YYYY HH:mm:ss a"),
          duration_to: ele.duration_to
            ? moment(ele.duration_to, "DD-MM-YYYY, HH:mm:ss a").format(
              "DD/MM/YYYY HH:mm:ss a",
            )
            : "",
        };
      });
      let other_bookings = tripData?.other_bookings?.map((ele) => {
        return {
          ...ele,
          departure_date: moment(
            ele.departure_date,
            "DD-MM-YYYY, HH:mm:ss a",
          ).format("DD/MM/YYYY HH:mm:ss a"),
        };
      });
      flight_reservations.trips = trips;
      const field_vals = {};

      fields.forEach((item) => {
        field_vals[item.field_id] =
          item.field_id === "trip_type" || item.field_id === "is_visa_required"
            ? (item.selected?.id ?? "")
            : (item?.selected?.value ?? "");
      });
      tripForm.setValues({
        field_values: field_vals,
        hotel_reservations: hotels ? hotels : [],
        car_rentals: car_rentals ? car_rentals : [],
        other_bookings: other_bookings ? other_bookings : [],
        flight_reservations: flight_reservations ? flight_reservations : {},
      });
    }
    if (!validationSchema && fields?.length) {
      const field_vals = {};
      const obj = {};

      fields.forEach((item) => {
        field_vals[item.field_id] =
          item.field_id === "trip_type" || item.field_id === "is_visa_required"
            ? (item.selected?.id ?? "")
            : (item?.selected?.value ?? "");
        if (item.is_required) {
          obj[item.field_id] = yup
            .string()
            .required(`${item.display_name} is required`)
            .nullable(`${item.display_name} is required`);
        }
      });
      setValidationSchema(
        yup.object().shape({ field_values: yup.object().shape(obj) }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fields, tripData]);
  const handleCancelButton = () => {
    history.push("/trips");
  };

  console.log(tripForm.errors.field_values);
  const renderDataTypes = (item) => {
    switch (item.field_type) {
      case "integer":
        return (
          <>
            <Input
              placeholder={`Enter ${item.display_name}`}
              style={{ minWidth: "216px", maxWidth: "300px" }}
              key={item.field_id}
              value={tripForm.values.field_values?.[item.field_id]}
              onChange={(e) => {
                if (Number.isNaN(Number(e.target.value)) && e.target.value) {
                  return;
                }
                let field_values = { ...tripForm.values.field_values };
                field_values[item.field_id] = e.target.value;
                tripForm.setFieldValue("field_values", field_values);
              }}
            />
            <div className="error">
              {tripForm.errors.field_values?.[item?.field_id]}
            </div>
          </>
        );
      case "string":
        return (
          <>
            <Input
              placeholder={`Enter ${item.display_name}`}
              style={{ minWidth: "216px", maxWidth: "300px" }}
              key={item.field_id}
              value={tripForm.values.field_values[item.field_id]}
              onChange={(e) => {
                let field_values = { ...tripForm.values.field_values };
                field_values[item.field_id] = e.target.value;
                tripForm.setFieldValue("field_values", field_values);
              }}
            />
            <div className="error">
              {tripForm.errors.field_values?.[item?.field_id]}
            </div>
          </>
        );
      case "dropdown":
        return (
          <>
            <Select
              style={{ width: 200 }}
              placeholder={`Select ${item.display_name}`}
              showSearch
              value={tripForm.values.field_values?.[item.field_id]}
              onChange={(val) => {
                let field_values = { ...tripForm.values.field_values };
                field_values[item.field_id] = val;
                tripForm.setFieldValue("field_values", field_values);
              }}
            >
              {item?.default_values &&
                item?.default_values.map(({ id, value }) => (
                  <Select.Option key={id} value={id}>
                    {value}
                  </Select.Option>
                ))}
            </Select>
            <div className="error">
              {tripForm.errors.field_values?.[item?.field_id]}
            </div>
          </>
        );
      default:
      // code block
    }
  };

  return (
    <div className="trips-detail detail-card">
      <div className="addTripHead">
        {tripData?.id ? "Edit Trip" : "New Trip Request"}
      </div>
      <section className="head">
        <form className="modal-form" onSubmit={tripForm.handleSubmit}>
          {fields.length
            ? fields.map((item) => {
              if (item.field_id === "destination_country") {
                item.field_type = "dropdown";
                item.default_values = countries?.map((ele) => ({
                  id: ele.value,
                  value: ele.value,
                }));
              }
              return (
                <div className="nameItem">
                  <label
                    className={`inline-block ${item.is_required ? "required" : ""}`}
                  >
                    {item.display_name}
                  </label>
                  <div>
                    {item.field_id === "purpose" ? (
                      <>
                        <Input.TextArea
                          rows={4}
                          placeholder={`Enter ${item.display_name}`}
                          maxLength={250}
                          key={item.field_id}
                          value={tripForm.values.field_values[item.field_id]}
                          onChange={(e) => {
                            let field_values = {
                              ...tripForm.values.field_values,
                            };
                            field_values[item.field_id] = e.target.value;
                            tripForm.setFieldValue(
                              "field_values",
                              field_values,
                            );
                          }}
                        />
                        <div className="error">
                          {tripForm.errors.field_values?.[item.field_id]}
                        </div>
                      </>
                    ) : (
                      renderDataTypes(item)
                    )}
                  </div>
                </div>
              );
            })
            : null}
          <p className="headLabels mt2">Trip Itinerary</p>
          <hr />
          <br />
          <Steps direction="vertical" current={100}>
            <Steps.Step
              subTitle={
                <FlightData
                  tripForm={tripForm}
                  isModalVisible={isFlightModalVisible}
                  setIsModalVisible={setIsFlightModalVisible}
                />
              }
              title="Flight"
              description=""
              icon={<ThunderboltFilled />}
            />
            <Steps.Step
              subTitle={
                <HotelForm
                  tripForm={tripForm}
                  isModalVisible={isHotelsModalVisible}
                  setIsModalVisible={setIsHotelsModalVisible}
                />
              }
              title="Hotel"
              description=""
              icon={<ThunderboltFilled />}
            />
            <Steps.Step
              subTitle={
                <CarRentals
                  tripForm={tripForm}
                  isModalVisible={isCarModalVisible}
                  setIsModalVisible={setIsCarModalVisible}
                />
              }
              title="Car Rentals"
              description=""
              icon={<ThunderboltFilled />}
            />
            <Steps.Step
              subTitle={
                <OtherBooking
                  tripForm={tripForm}
                  isModalVisible={isOtherModalVisible}
                  setIsModalVisible={setIsOtherModalVisible}
                />
              }
              title="Other Bookings"
              description=""
              icon={<ThunderboltFilled />}
            />
          </Steps>
          <div>
            <Button
              key="1"
              htmlType="submit"
              className="formButton mt3 primaryButton"
              disabled={userTripsAddResponse?.loading}
            >
              Submit
            </Button>
            <Button
              key="2"
              className="cancelButton ml1 mt3 "
              onClick={() => handleCancelButton()}
            >
              Cancel
            </Button>
          </div>
        </form>
      </section>
    </div>
  );
};

export default AddTripComponent;
